import lottie from 'lottie-web';
import React, { useCallback, useEffect, useRef } from "react";
import { bool, string } from 'prop-types';

if (!window.lottie) {
  window.lottie = lottie;
}

/** @typedef {import("lottie-web").AnimationItem} AnimationItem*/

export default Lottie;

Lottie.propsTypes = {
  className: string,
  autoplay: bool,
  loop: bool,
  /** @deprecated use `path` or `animationData` instead */
  animation: string,
  path: string,
  animationData: string,
};

Lottie.defaultProps = {
  autoplay: true,
  loop: false,
};

function Lottie({
                  className,
                  autoplay,
                  loop,
                  /** @deprecated use `path` or `animationData` instead */
                  animation,
                  path = animation,
                  animationData,
                  name,
                  ...props
                }) {
  const selfRef = useRef();
  const {
    onBegin = Function.prototype,
    onComplete = Function.prototype,
  } = props;

  /**
   *
   * @type {React.MutableRefObject<AnimationItem>}
   */
  const instanceRef = useRef();

  const play = useCallback(() => {
    if (!instanceRef.current) {
      return;
    }
    instanceRef.current.play();
  }, [instanceRef]);

  const stop = useCallback(() => {
    if (!instanceRef.current) {
      return;
    }
    instanceRef.current.stop();
  }, [instanceRef]);

  useEffect(() => {
      const instance = lottie.loadAnimation({
        container: selfRef.current,
        loop,
        autoplay,
        path: path || animation,
        renderer: 'svg',
        /* Due to LottiePlayer try to mutate passed data it absolutely necessary to clone data before pass into that scrap. */
        animationData: animationData && JSON.parse(animationData),
        name: `button_${name}`,
      });
      instanceRef.current = instance;

      /*
          instance.onComplete = () => {
            // debugger;
            props.onComplete && props.onComplete();
          };
      */

      onBegin();

      return () => {
        instance.destroy();
        onComplete();
      };
    },
    [/* eslint-disable-line react-hooks/exhaustive-deps */],
  );

  return (
    <div ref={selfRef} className={className} onMouseOver={play} onMouseOut={stop} />
  );
}
